export default __webpack_public_path__ + "static/upgrade-modal-bg-0312001218093c628c148c7dc076d146.jpg";